import theme from "@shared/utils/themeColors";
import { useCallback, useEffect, useRef } from "react";
import { usePostStore } from "../../store/postStore";
import { SinglePost } from "./SinglePost";

export function PostList() {
  const { posts, loading, error, fetchPosts, hasNextPage, currentPage } =
    usePostStore();
  const observer = useRef<IntersectionObserver | null>(null);

  // Load initial posts
  useEffect(() => {
    fetchPosts(1);
  }, [fetchPosts]);

  const lastPostElementRef = useCallback(
    (node: HTMLDivElement) => {
      if (loading) return;

      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasNextPage) {
          fetchPosts(currentPage + 1);
        }
      });

      if (node) observer.current.observe(node);
    },
    [loading, hasNextPage, fetchPosts, currentPage]
  );

  if (error) {
    return (
      <div className={`${theme.text.error} dark:text-red-400 text-center py-4`}>
        {error}
      </div>
    );
  }

  if (!posts.length && !loading) {
    return (
      <div className={`text-center p-4 ${theme.text.muted}`}>
        No posts found
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {posts.map((post, index) => (
        <div
          key={post.id}
          ref={index === posts.length - 1 ? lastPostElementRef : undefined}
        >
          <SinglePost post={post} />
        </div>
      ))}
      {loading && (
        <div className="flex justify-center items-center h-16">
          <div
            className={`animate-spin rounded-full h-8 w-8 border-b-2 ${theme.border.brand}`}
          ></div>
        </div>
      )}
    </div>
  );
}
